import { Box, Typography } from '@mui/material';

import PageWrapper from 'Components/PageWrapper';
import ScrollTopFab from 'Components/ScrollTopFab';

const NotFoundView = () => {
  return (
    <>
      <ScrollTopFab />
      <PageWrapper>
        <Box display="flex" flexDirection="column" height="100%" justifyContent="center">
          <Typography align="center" color="textPrimary" variant="h1">
            404: The page you are looking for isn’t here
          </Typography>
          <Typography align="center" color="textPrimary" variant="subtitle2">
            That address doesn&apos;t match a page on this site. Use the navigation above to find
            what you&apos;re looking for.
          </Typography>
          <Box textAlign="center">
            <img
              alt="Under development"
              style={{
                mt: 50,
                display: 'inline-block',
                maxWidth: '100%',
                width: 560,
              }}
              src=""
            />
          </Box>
        </Box>
      </PageWrapper>
    </>
  );
};

export default NotFoundView;
